import { addStyles } from 'ethcss'
import { colors, grid, IStyles, item } from '../../../theme'
import { defaultThemeStyles } from 'blocks.app/sidebar/Sidebar-theme'

const updateDevicesToolbarStyles: IStyles = {
    menuItem: {
        ...grid.row,
        ...grid.normalCenter,
        ...grid.center,
        ...grid.p_mini,
        cursor: 'pointer',
        position: 'relative',
        color: `var(--var-module-sidebar-component-sidebar-style-menuText, ${defaultThemeStyles.menuText})`,
        ...item.transitionErase,
        '&:hover': {
            color: `var(--var-module-sidebar-component-sidebar-style-menuTextHover, ${defaultThemeStyles.menuTextHover})`,
        },
        textAlign: 'center',
    },
    device: {
        backgroundColor: colors.white,
        marginBottom: 24,
    },
    deviceTop: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: colors.white,
        height: 42,
    },
    deviceCenter: {
        paddingBottom: '56%',
    },
    deviceBottom: {
        height: 42,
    },
}

addStyles(updateDevicesToolbarStyles)
export default updateDevicesToolbarStyles
